import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "./ErrorBoundary";
import { LoadingState } from "./LoadingState";

interface SuspenseWrapperProps {
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Composes Suspense + ErrorBoundary.
 * Use this to wrap all lazy-loaded route components.
 */
export function SuspenseWrapper({ children, fallback }: SuspenseWrapperProps) {
  return (
    <ErrorBoundary>
      <Suspense fallback={fallback ?? <LoadingState />}>{children}</Suspense>
    </ErrorBoundary>
  );
}
